export const detectMultiSelect = (
  arr: Array<{ correct?: boolean | null; id: string }>
): string[] => {
  return arr
    .filter(
      (item: { correct?: boolean | null; id: string }) => item.correct === true
    )
    .map((item: { correct?: boolean | null; id: string }) => item.id);
};
